import { SvgIcon } from '@mui/material';

const EasyCustoms = props => (
  <SvgIcon width='25' height='25' viewBox='0 0 25 25' {...props}>
    <g id='Group_174' data-name='Group 174' transform='translate(-797 -380)'>
      <circle
        id='Ellipse_8'
        data-name='Ellipse 8'
        cx='12.5'
        cy='12.5'
        r='12.5'
        transform='translate(797 380)'
        fill='#fff'
      />
      <g
        id='Group_173'
        data-name='Group 173'
        transform='translate(799.568 383.704)'
      >
        <path
          id='Path_84'
          data-name='Path 84'
          d='M13.494,4.446h-.006A1.458,1.458,0,0,0,12.05,3.189h-.459a1.752,1.752,0,0,0-3.319,0H7.82A1.448,1.448,0,0,0,6.387,4.446H6.376A1.756,1.756,0,0,0,4.62,6.2v7.645a1.756,1.756,0,0,0,1.756,1.75h7.119a1.755,1.755,0,0,0,1.75-1.75V6.2A1.755,1.755,0,0,0,13.494,4.446ZM11.8,9.465,9.892,11.374a.566.566,0,0,1-.8,0L8.064,10.346a.566.566,0,0,1,.8-.8l.627.627L11,8.664a.566.566,0,0,1,.8.8Zm.572-4.225a.323.323,0,0,1-.323.323H7.82A.326.326,0,0,1,7.5,5.239V4.645a.323.323,0,0,1,.323-.323h.929a.568.568,0,0,0,.566-.566.62.62,0,1,1,1.24,0,.564.564,0,0,0,.566.566h.929a.319.319,0,0,1,.323.323Z'
          fill='#dc0132'
        />
      </g>
    </g>
  </SvgIcon>
);

export default EasyCustoms;
